import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            redirect: '/index',
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "index" */ '../common/Home.vue'),
            meta: { title: '策略', tagShow: false },
            children: [
                { path: '/index', component: () => import(/* webpackChunkName: "dashboard" */ '../views/marketOverview/index.vue'), meta: { title: '全市场策略概览', tagShow: false } },
                { path: '/analysis', component: () => import(/* webpackChunkName: "dashboard" */ '../views/managerCompare/index.vue'), meta: { title: '基金经理画像对比', tagShow: false } },
                { path: '/health', component: () => import(/* webpackChunkName: "dashboard" */ '../views/poolHealth/index.vue'), meta: { title: '池健诊', tagShow: false } },
            ],
        },
        {
            path: '*',
            redirect: '/404',
        },
    ],
})

export default router
